/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SalesforceConfigurationConductor_viewer = {
    readonly company: {
        readonly newSalesforceEnabled: boolean | null;
    } | null;
    readonly " $refType": "SalesforceConfigurationConductor_viewer";
};
export type SalesforceConfigurationConductor_viewer$data = SalesforceConfigurationConductor_viewer;
export type SalesforceConfigurationConductor_viewer$key = {
    readonly " $data"?: SalesforceConfigurationConductor_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SalesforceConfigurationConductor_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SalesforceConfigurationConductor_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newSalesforceEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '34be013738256a443867af8e4d376ae1';
export default node;
